import type { Environment } from '../models/environment.model';

// LOCAL (default). Used by `ng serve` and `ng build -c development`.
export const environment: Environment = {
  name: 'local',
  apiUrl: 'http://localhost:3000',
  useMockData: true,
  apiKey: '<LOCAL_API_KEY>',
  chatUrl: 'https://generativeaiuat.clariant.com/?compact=true&nav=false&panel=false',
  apiScopes: ['api://<LOCAL_ENTRA_APP_ID>/access_as_user'],
  skipAuth: true,
  authConfig: {
    auth: {
      clientId: '<LOCAL_ENTRA_APP_ID>',
      authority: 'https://login.microsoftonline.com/<TENANT_ID>',
      redirectUri: location.origin,
      postLogoutRedirectUri: location.origin,
    },
    cache: { cacheLocation: 'sessionStorage' },
  },
};
